import React from 'react';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import Heading from '../../common/Heading';
import TextInput from '../../common/FormFields/TextInput';
import RadioGroupInput from '../../common/FormFields/RadioGroupInput';
import formStyles from '../../styles/forms.module.scss';
import s from './StepBusinessChargingData.module.scss';

function StepBusinessChargingData() {
  return (
    <section className={s.section}>
      <Heading level={2} className={s.heading}>
        <FormattedMessage id="offerWizard.stepBusinessChargingData.title" />
      </Heading>
      <div className={formStyles.formFields}>
        <div className={formStyles.inputPair}>
          <Field
            name="businessChargingData.numberOfEmployees"
            component={TextInput}
            labelMsg="offerWizard.stepBusinessChargingData.numberOfEmployees"
          />
          <Field
            name="businessChargingData.numberOfParkingSpaces"
            component={TextInput}
            labelMsg="offerWizard.stepBusinessChargingData.numberOfParkingSpaces"
          />
        </div>
        <div className={formStyles.inputWithVerticalSpacing}>
          <Field
            captionMsg="offerWizard.stepBusinessChargingData.isOwnParkingLot"
            name="businessChargingData.isOwnParkingLot"
            options={[
              {
                value: 'true',
                labelMsg: 'yes',
              },
              {
                value: 'false',
                labelMsg: 'no',
              },
            ]}
            component={RadioGroupInput}
            radioButtonsWrapperClass={s.radioButtonsInRow}
          />
        </div>
        <div className={formStyles.inputWithVerticalSpacing}>
          <Field
            captionMsg="offerWizard.stepBusinessChargingData.hasOwnCarFleet"
            name="businessChargingData.hasOwnCarFleet"
            options={[
              {
                value: 'true',
                labelMsg: 'yes',
              },
              {
                value: 'false',
                labelMsg: 'no',
              },
            ]}
            component={RadioGroupInput}
            radioButtonsWrapperClass={s.radioButtonsInRow}
          />
        </div>
        <div className={formStyles.inputPair}>
          <Field
            name="businessChargingData.numberOfOwnVehicles"
            component={TextInput}
            labelMsg="offerWizard.stepBusinessChargingData.numberOfOwnVehicles"
          />
          <Field
            name="businessChargingData.numberOfElectricCars"
            component={TextInput}
            labelMsg="offerWizard.stepBusinessChargingData.numberOfElectricCars"
          />
        </div>
        <div className={formStyles.inputWithVerticalSpacing}>
          <Field
            captionMsg="offerWizard.stepBusinessChargingData.isCustomerParkingAllowed"
            name="businessChargingData.isCustomerParkingAllowed"
            options={[
              {
                value: 'true',
                labelMsg: 'yes',
              },
              {
                value: 'false',
                labelMsg: 'no',
              },
            ]}
            component={RadioGroupInput}
            radioButtonsWrapperClass={s.radioButtonsInRow}
          />
        </div>
      </div>
    </section>
  );
}

export default StepBusinessChargingData;
